import React, { useMemo } from 'react'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { DatePicker } from 'antd'

/**
 * handles date and time with format "DD/MM/YYYY HH:mm", the value is a UTC ISO string.
 * The picker displays the value in `tz`, and onChange returns a UTC ISO string
 * anchored in `tz` (i.e. the wall-clock the user picked, interpreted as being in `tz`).
 * @param params.tz: string | null = dayjs.tz.guess()
 * @param params.value: string | null
 * @param params.onChange: (value: string | null) => void
 * @returns jsx
 */
export default function DateTimeInput({
    tz = dayjs.tz.guess(),
    value,
    onChange,
    format = 'DD/MM/YYYY HH:mm',
    placeholder,
    ...otherProps
}) {
    const { t } = useTranslation()

    const dayjsValue = useMemo(() => (value ? dayjs(value).tz(tz) : null), [value, tz])
    const toUtc = (r) => (r ? dayjs.tz(r.format('YYYY-MM-DDTHH:mm:ss'), tz).utc().format() : null)

    return (
        <DatePicker
            value={dayjsValue}
            onChange={(result) => onChange(toUtc(result))}
            format={format}
            showTime
            placeholder={placeholder || t('Select date')}
            {...otherProps}
        />
    )
}

